import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const getUserAuth = () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
        return { isAuthenticated: false, isAdmin: false };
    }
    try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 < Date.now()) {
            localStorage.removeItem('accessToken');
            return { isAuthenticated: false, isAdmin: false };
        }
        return { isAuthenticated: true, isAdmin: decoded.is_admin };
    } catch (e) {
        return { isAuthenticated: false, isAdmin: false };
    }
};

const AdminRoute = () => {
    const { isAuthenticated, isAdmin } = getUserAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    return isAdmin ? <Outlet /> : <Navigate to="/" />;
};

export default AdminRoute;
